/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/


type _KontoMandantStatus = "BESITZER" | "AKTIV" | "EINGELADEN"

type Leer = "";

type KontoMandantStatus = _KontoMandantStatus | Leer;

export default KontoMandantStatus;

export class KontoMandantStatusSammlung {
    public static readonly besitzer: KontoMandantStatus = "BESITZER";
    public static readonly aktiv: KontoMandantStatus = "AKTIV";
    public static readonly eingeladen: KontoMandantStatus = "EINGELADEN";
    public static readonly leer: KontoMandantStatus = "";
}
